// extracted by mini-css-extract-plugin
export default {"buttonRegisterContainer":"ButtonRegister_buttonRegisterContainer__B5qtc","button":"ButtonRegister_button__w18En"};